import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { editProfileField } from '../../stores/profile/company/profile-actions';
import { editLocationField } from '../../stores/profile/location/location-actions';
import { editProductField } from '../../stores/profile/product/product-actions';
import { clearEditModalState, editFieldForModal, startEdit, startInlineEdit } from '../../stores/profile-edit-modal/profile-edit-modal-actions';
import Address from './company-address';
import EditFieldModal from './edit-modal/edit-field-modal-container';
import ProfileContent from './content';
import ProfileLeftBar from './profile-left-bar/profile-left-bar-container';
import ProfileTopBar from './profile-top-bar/profile-top-bar-container';
import { cond, always, equals, either, T, identity, path, call } from 'ramda';

const toCapitalizedWords = name => {
  if (name === 'bedsAndSofas') return 'Bedding Configuration';
  const words = name.match(/[A-Za-z][a-z]*/g);
  return words.map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
};

class Profile extends Component {

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(equals(nextProps, this.props) && equals(nextState, this.state));
  }

  sendEditToReducer = (update) => {
    const { dispatch } = this.props;
    dispatch(editFieldForModal(update));
  };

  clearModalState = () => {
    const { dispatch } = this.props;
    dispatch(clearEditModalState());
  };

  shouldLocationUpdateForSingleLocUpdate = (updateField) => {
    const singleLocFields = ['contacts', 'description', 'website', 'phone', 'address', 'companyTypes', 'marketSegments', 'coverImageUrl'];
    return (singleLocFields.indexOf(updateField) > -1);
  };

  shouldLocationUpdateInsteadOfProfileForSingleLoc = (updateField) => {
    const singleLocFields = ['notes', 'imageUrls', 'rating', 'amenities', 'roomCount'];
    return (singleLocFields.indexOf(updateField) > -1);
  };

  submitEdit = ({ route, ...options }) => {
    const { routeName, params: { productId }, profileToShow: { locationId }, user, dispatch } = this.props;
    const isOneLocationSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';
    options.isSingleLocSupplier = isOneLocationSupplier;
    const singleLocId = user.company.singleLocId;
    const checkIfSingleLocToUpdate = routeName === 'profile' &&
      isOneLocationSupplier &&
      this.shouldLocationUpdateInsteadOfProfileForSingleLoc(options.updateField) ? 'location' : routeName;
    const routeToCheck = route || checkIfSingleLocToUpdate;
    call(cond([
      [equals('profile'), () => {
        dispatch(editProfileField(options));
        dispatch(clearEditModalState());
        if (isOneLocationSupplier && this.shouldLocationUpdateForSingleLocUpdate(options.updateField)) {
          dispatch(editLocationField({ ...options, id: singleLocId || locationId }));
        }
      }],
      [equals('location'), () => {
        dispatch(editLocationField({ ...options, id: singleLocId || locationId }));
        dispatch(clearEditModalState());
      }],
      [equals('product'), () => {
        dispatch(editProductField({ ...options, id: productId, locationId }));
        dispatch(clearEditModalState());
      }],
    ]), routeToCheck);
  };

  editField = (field, settings = {}) => {
    const { dispatch, routeName } = this.props;
    const getFieldName = cond([
      [either(equals('locationName'), equals('productName')), always('Name')],
      [T, identity],
    ]);
    const fieldName = getFieldName(field);
    const title = settings.title || `Edit Your ${this._descriptionType(routeName)}'s ${toCapitalizedWords(fieldName)}`;
    dispatch(startEdit({ field, value: settings.initialValue || this.props.profileToShow[field], title, settings }));
  };

  inlineEditField = (field, settings = {}) => {
    const { dispatch, routeName } = this.props;
    const getFieldName = cond([
      [either(equals('locationName'), equals('productName')), always('Name')],
      [T, identity],
    ]);
    const fieldName = getFieldName(field);
    const title = settings.title || `Edit Your ${this._descriptionType(routeName)}'s ${toCapitalizedWords(fieldName)}`;
    dispatch(startInlineEdit({ field, value: settings.initialValue || this.props.profileToShow[field], title, settings }));
  };

  _descriptionType = cond([
    [equals('profile'), always('Company')],
    [equals('location'), always('Location')],
    [equals('product'), always('Product')],
  ]);

  render() {
    const {
      profileToShow,
      user,
      dispatch,
      location,
      params,
      connectionsStats,
      children,
      isEditable,
      history,
      routeName,
      triggerSnackBarMessage,
      updateUpgradeSource,
      previewingOwnProfile,
    } = this.props;

    // const routedFromPF = docCookies.getItem('fromPF'); // viewing profile from PF
    // const isViewingOwnProfile = !isNilOrEmpty(profileToShow.connectionInfo) && equals(profileToShow.companyId, path(['user', 'userID'], user));
    const isViewingOwnProfile = previewingOwnProfile;
    const isSingleLocSupplier = path(['company', 'oneOrMultiProperties'], user) === 'one-prop';

    return (
      <div>
        {this.props.isEditable ?
          <EditFieldModal
            clearModalState={this.clearModalState}
            sendEditToReducer={this.sendEditToReducer}
            _saveField={this.submitEdit}
            {...this.props}
            ref="editFieldModal"
          /> : undefined}
        <div>
          <ProfileTopBar
            isViewingOwnProfile={isViewingOwnProfile}
            editField={this.editField}
            inlineEditField={this.inlineEditField}
            _saveField={this.submitEdit}
            basicUser={Boolean(user.billingPlan === 'none' || user.billingPlan === 'basic')}
            isSingleLocSupplier={isSingleLocSupplier}
            singleLocId={user.company.singleLocId}
            {...this.props}
          />
        </div>
        <div className="l-app-content l-app-profile-content">
          <div className="l-profile-content">
            <div className="l-profile-left-content">
              <ProfileLeftBar
                editField={this.editField}
                inlineEditField={this.inlineEditField}
                _saveField={this.submitEdit}
                isSingleLocSupplier={isSingleLocSupplier}
                {...this.props}
              />
            </div>
            <div className="l-profile-right-content">
              <ProfileContent
                editField={this.editField}
                inlineEditField={this.inlineEditField}
                sendEditToReducer={this.sendEditToReducer}
                clearEditState={this.clearModalState}
                _saveField={this.submitEdit}
                isEditing
                isViewingOwnProfile={isViewingOwnProfile}
                {...this.props}
              />
            </div>
          </div>
        </div>
        <div className="l-profile-address">
          <Address address={profileToShow.address} className="address-data" />
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  isEditable: PropTypes.bool,
  dispatch: PropTypes.func,
  routeName: PropTypes.string,
  params: PropTypes.object,
  profileToShow: PropTypes.object,
  user: PropTypes.object,
  location: PropTypes.object,
  connectionsStats: PropTypes.object,
  children: PropTypes.object,
  history: PropTypes.object,
  triggerSnackBarMessage: PropTypes.func,
  updateUpgradeSource: PropTypes.func,
  previewingOwnProfile: PropTypes.bool,
};

const mapStateToProps = ({ profile }) => ({
  previewingOwnProfile: profile.get('previewingOwnProfile') || false,
});

export default connect(mapStateToProps)(Profile);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.jsx